module.exports = __webpack_public_path__ + "img/logo.6de594c0.png";